import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, SecurityContext} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {Subject} from 'rxjs';
import {filter, take, takeUntil} from 'rxjs/operators';
import {UserService} from '../../../shared/services/user.service';
import {HttpClient} from '@angular/common/http';
import {ProfilePictureCacheWrapper, ProfilePictureProvider} from './profile-picture.provider';

@Component({
  selector: 'app-nav-profile-picture',
  templateUrl: './nav-profile-picture.component.html',
  styleUrls: ['./nav-profile-picture.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavProfilePictureComponent implements OnInit, OnDestroy {
  private ngUnsubscribe = new Subject<void>();
  public userImage: SafeUrl;
  constructor(
    private sanitizer: DomSanitizer,
    private userService: UserService,
    private cd: ChangeDetectorRef,
    private httpClient: HttpClient
  ) {}

  ngOnInit(): void {
    this.userService
      .getLoggedInProduceit()
      .pipe(
        filter(l => !!l),
        take(1),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe(async () => {
        try {
          const cachedWrapper = new ProfilePictureCacheWrapper(new ProfilePictureProvider(this.httpClient));

          const userImage: Blob = await cachedWrapper.getProfilePicture(this.userService.getCurrentUserName());
          if (userImage) {
            this.userImage = this.sanitizer.bypassSecurityTrustUrl(
              this.sanitizer.sanitize(SecurityContext.NONE, URL.createObjectURL(userImage))
            );
            this.cd.markForCheck();
          }
        } catch (e) {
          console.log(e);
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
